<main
  class="payment-methods-component"
  [class.desktop]="!(lessThan$ | async)?.sm"
  [class.single-header]="!(lessThan$ | async)?.mobileXL"
  *transloco="let t">
  <div class="wrapper scroll" id="mainAppScroll">
    <div class="content">
      <article class="content-wrapper">
        <section class="flex flex-col full-width">
          @if (lang !== 'AR') {
            <h1>Payment Methods</h1>
          } @else {
            <h1>الشحن والتسليم</h1>
          }
          @if (lang !== 'AR') {
            <div class="rte">
              <p>
                We want to make buying your favorite electronics fast and easy, and we
                accept the following payment options:
              </p>
              <div class="methods">
                <p class="bold">Credit cards</p>
                <div class="flex gap-8">
                  <p>Visa</p>
                  <p>-</p>
                  <p>MasterCard</p>
                  <p>-</p>
                  <p>American Express</p>
                  <p>-</p>
                  <p>Discover</p>
                  @if (displayMada() === true) {
                    <p>-</p>
                    <p>Mada</p>
                  }
                </div>
                <span class="fixed-space-12" aria-hidden="true"></span>

                <p class="bold">Wallets</p>
                <div class="flex gap-8">
                  <p>Apple Pay</p>
                  <p>-</p>
                  <p>Google Pay</p>
                  @if (displaySTC() === true) {
                    <p>-</p>
                    <p>STC Pay</p>
                  }
                </div>

                @if (displayTabby() === true || displayTamara() === true) {
                  <span class="fixed-space-12" aria-hidden="true"></span>

                  <p class="bold">Buy Now Pay Later, up to 6 installments</p>
                  <div class="flex gap-8">
                    @if (displayTabby() === true) {
                      <p>Tabby</p>
                    }
                    @if (displayTamara() === true) {
                      <p>-</p>
                      <p>Tamara</p>
                    }
                  </div>
                }

                @if (displayBaseeta() === true || displayQuara() === true) {
                  <span class="fixed-space-12" aria-hidden="true"></span>

                  <p class="bold">Financing Services, up to 36 installments</p>

                  <div class="flex gap-8">
                    @if (displayQuara() === true) {
                      <p>Quara</p>
                    }
                    @if (displayBaseeta() === true) {
                      <p>-</p>
                      <p>Baseeta</p>
                    }
                  </div>
                }
              </div>
              <p>
                Please keep in mind that once you've completed the checkout procedure,
                your order will be handled right away. You'll receive an email
                confirmation as well as tracking updates to keep track of your order's
                progress once it's ready to ship.
              </p>
            </div>
          } @else {
            <div class="rte">
              <p>
                نريد أن نجعل عملية شراء الإلكترونيات المفضلة لديك سريعة وسهلة، ونقبل
                الخيارات الدفعية التالية:
              </p>
              <div class="methods">
                <p class="bold">بطاقات الائتمان</p>
                <div class="flex gap-8">
                  <p>فيزا</p>
                  <p>-</p>
                  <p>ماستركارد</p>
                  <p>-</p>
                  <p>أمريكان إكسبريس</p>
                  <p>-</p>
                  <p>ديسكفر</p>
                  @if (displayMada() === true) {
                    <p>-</p>
                    <p>مدى</p>
                  }
                </div>
                <span class="fixed-space-12" aria-hidden="true"></span>

                <p class="bold">المحافظ الإلكترونية</p>
                <div class="flex gap-8">
                  <p>أبل باي</p>
                  <p>-</p>
                  <p>جوجل باي</p>
                  @if (displaySTC() === true) {
                    <p>-</p>
                    <p>STC باي</p>
                  }
                </div>

                @if (displayTabby() === true || displayTamara() === true) {
                  <span class="fixed-space-12" aria-hidden="true"></span>

                  <p class="bold">تسوق الآن وادفع لاحقاً، حتى 6 أقساط</p>
                  <div class="flex gap-8">
                    @if (displayTabby() === true) {
                      <p>Tabby</p>
                    }
                    @if (displayTamara() === true) {
                      <p>-</p>
                      <p>Tamara</p>
                    }
                  </div>
                }

                @if (displayBaseeta() === true || displayQuara() === true) {
                  <span class="fixed-space-12" aria-hidden="true"></span>

                  <p class="bold">خدمات التمويل، حتى 36 قسط</p>

                  <div class="flex gap-8">
                    @if (displayQuara() === true) {
                      <p>Quara</p>
                    }
                    @if (displayBaseeta() === true) {
                      <p>-</p>
                      <p>Baseeta</p>
                    }
                  </div>
                }
              </div>
              <p>
                يرجى الانتباه إلى أنه بمجرد إكمال إجراءات الدفع، سيتم التعامل مباشرة مع
                طلبك. ستتلقى تأكيدًا عبر البريد الإلكتروني بالإضافة إلى تحديثات المتابعة
                لتتبع تقدم طلبك بمجرد أن يكون جاهزًا للشحن.
              </p>
            </div>
          }

          <span class="fixed-space-32" aria-hidden="true"></span>

          @if (
            displayBaseeta() === true ||
            displayQuara() === true ||
            displayTabby() === true ||
            displayTamara() === true
          ) {
            <div class="popsy-card gray">
              @if (lang !== 'AR') {
                <h2>Financing Services - Buy Now Pay Later</h2>
              } @else {
                <h2>تسوق الآن وادفع لاحقاً</h2>
              }
              <span class="fixed-space-16" aria-hidden="true"></span>
              <div class="icon-list">
                @if (displayQuara() === true) {
                  <popsy-icon-quara class="icon"></popsy-icon-quara>
                }
                @if (displayBaseeta() === true) {
                  <popsy-icon-baseeta-badge-en class="icon"></popsy-icon-baseeta-badge-en>
                }
                @if (displayTabby() === true) {
                  <popsy-icon-tabby class="icon"></popsy-icon-tabby>
                }
                @if (displayTamara() === true) {
                  <popsy-icon-tamara class="icon"></popsy-icon-tamara>
                }
              </div>

              <span class="fixed-space-16" aria-hidden="true"></span>
              <a
                class="flex flex-col"
                [routerLink]="getInfoFragment('installment-plans')"
                [queryParams]="queryParams$ | async">
                <p class="popsy-button-option">
                  @if (lang !== 'AR') {
                    Read more
                  } @else {
                    قراءة المزيد
                  }
                </p>
              </a>

              <span class="fixed-space-16" aria-hidden="true"></span>
            </div>
          }
          <app-other-topics></app-other-topics>

          <span class="fixed-space-64" aria-hidden="true"></span>
        </section>
      </article>
      @if ((lessThan$ | async)?.mobileL !== true) {
        <span class="fixed-space-64" aria-hidden="true"></span>
      }
      @if (!(inFullScreenMode$ | async)) {
        <app-footer
          class="footer"
          [class.phone]="(lessThan$ | async)?.mobileL"></app-footer>
      }
    </div>
  </div>
</main>
